export default __webpack_public_path__ + "static/media/roles-permission-red.4bf0cd3f.svg";